import { Info } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import { useProject } from 'contexts/project'
import ProjectViewConnectorAndAppCard from './card'
import { useStyles } from './styles'

const ProjectViewConnectorsAndApps: React.FC = () => {
  const { data: project } = useProject()
  const classes = useStyles()

  const connectorsInput = project?.connectors
    .sort((a, b) => a.position - b.position)
    .filter((connector) => connector.connectorTypeName !== 'output')
  const connectorOutput = project.connectors.find((connector) => connector.connectorTypeName === 'output')

  return (
    <Box>
      <Box className={classes.containerHeader}>
        <h1>Conectores</h1>
        <Button
          type='button'
          variant='outlined'
          disabled
        >
          Novo conector
        </Button>
      </Box>

      <Box className={classes.rootContent}>
        <Box className={classes.cardLabel}>
          <h5>Conectores de entrada</h5>
          <Info
            fontSize='small'
            color='disabled'
          />
        </Box>

        {connectorsInput.length > 0 &&
          connectorsInput.map((connector) => (
            <ProjectViewConnectorAndAppCard
              connector={connector}
              lastUpdate={connector.updatedAt}
              name={connector.name}
              status={connector.status}
              type={connector.key}
            />
          ))}

        <Box className={classes.cardLabel}>
          <h5>Conectores de saida</h5>
          <Info
            fontSize='small'
            color='disabled'
          />
        </Box>

        {connectorOutput && (
          <ProjectViewConnectorAndAppCard
            connector={connectorOutput}
            lastUpdate={connectorOutput.updatedAt}
            name={connectorOutput.name}
            status={connectorOutput.status}
            type={connectorOutput.key}
          />
        )}
      </Box>

      <Box className={classes.containerHeader}>
        <h1>Apps</h1>
        <Button
          type='button'
          variant='outlined'
          disabled
        >
          Novo App
        </Button>
      </Box>

      <Box className={classes.rootContent}>
        {project?.recipes
          .filter((recipe) => recipe.type === 'app')
          .map((recipe) => (
            <ProjectViewConnectorAndAppCard
              key={recipe.id + Math.random()}
              lastUpdate={recipe.lastUpdate!}
              name={recipe.appName}
              status={recipe.status!}
              type={recipe.type}
            />
          ))}
      </Box>
    </Box>
  )
}

export default ProjectViewConnectorsAndApps
